export default {
  'redeemPoint.title': 'แลกแต้ม',
  'redeemPoint.collect_success': 'สะสมแต้มสำเร็จ',
  'redeemPoint.redeem_success': 'แลกแต้มสำเร็จ',
  'redeemPoint.redeem_fail': 'แลกแต้มล้มเหลว',
  'redeemPoint.point_not_enough': 'แต้มของคุณไม่เพียงพอสำหรับการแลก',
  'redeemPoint.please_enter_quantity': 'กรุณากรอกจำนวนแต้มที่ต้องการแลก',
  'redeemPoint.next_step': 'ขั้นตอนถัดไป',
} as Record<string, string>;
